import axios from 'axios'
import PostService from './post'
import RHService from './rh'
import MenuService from './menu'
import CommentService from './comment'
import AuthService from './auth'
import config from '../../config'



const authHttp = axios.create({
    withCredentials: true,
    baseURL: config.authApiUrl,
})

const auth = new AuthService(authHttp)

async function invalidTokenBreaker()
{
    let res = await auth.getAuthorizationUrl()

    if(res.status == 200)
    {
        sessionStorage.removeItem('user-data')
        location = res.data.authorization_url
    }
    else
        console.error('Could not get login url')
}



const http = axios.create({
    withCredentials: true,
    baseURL: config.apiUrl,
})

http.interceptors.response.use(
    async response => {

        if( [401, 403].indexOf(response.status) > -1 )
            await invalidTokenBreaker()

        return response;
    },
    async error => {
        return Promise.reject(error);
    }
);

export default {
    post: new PostService(http),
    rh: new RHService(http),
    menu: new MenuService(http),
    comment: new CommentService(http),
    auth
}